export default {
    path: 'warning_list',
    component: () => import( /* webpackChunkName: "warning-list" */ '@/pages/warn/WarningList'),
    meta: {
        title: '预警记录'
    }
}